import React from 'react';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="flex flex-col gap-3 border-b border-line pb-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-5248" data-mp="krq5wy4k8ibn">
      <div className="min-w-0" data-id="element-5249" data-mp="ptfkuouwlg50">
        {eyebrow && <p className="text-body-sm font-medium text-ink-muted" data-id="element-5250" data-mp="ttfy4669nlah">{eyebrow}</p>}
        <h1 className="mt-1 text-h2 font-semibold tracking-tight text-ink lg:text-h1" data-id="element-5251" data-mp="trd9nqkri07v">{title}</h1>
        {description && <p className="mt-2.5 max-w-[62ch] text-body-lg text-ink-muted" data-id="element-5252" data-mp="13jj211exejnl">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 sm:shrink-0" data-id="element-5253" data-mp="18ilxbu53tbid">{actions}</div>}
    </div>;
}